import crud from './crud'
import credentials from './credentials'
import scopes from './scopes'
import serviceAccountRoles from './serviceAccountRoles'

export default {
    namespaced: true,
    state: {
        ...crud.state,
        ...credentials.state,
        ...scopes.state,
        ...serviceAccountRoles.state,
    },
    mutations: {
        ...crud.mutations,
        ...credentials.mutations,
        ...scopes.mutations,
        ...serviceAccountRoles.mutations,
    },
    actions: {
        ...crud.actions,
        ...credentials.actions,
        ...scopes.actions,
        ...serviceAccountRoles.actions,
    }
}